/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const ReportType = {
    EMPLOYEES_ELIGIBLE_REPORT: 'EMPLOYEES_ELIGIBLE_REPORT'
} as const;
export type ReportType = typeof ReportType[keyof typeof ReportType];

